var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9889 12.8938C35.799 12.1895 35.4281 11.5472 34.9128 11.0308C34.3976 10.5144 33.7561 10.1419 33.0522 9.95051C30.4422 9.23385 20.0005 9.22218 20.0005 9.22218C20.0005 9.22218 9.56055 9.21051 6.94888 9.89551C6.24542 10.0958 5.60525 10.4735 5.08983 10.9924C4.5744 11.5113 4.20103 12.154 4.00555 12.8588C3.31722 15.4688 3.31055 20.8822 3.31055 20.8822C3.31055 20.8822 3.30388 26.3222 3.98722 28.9055C4.37055 30.3338 5.49555 31.4622 6.92555 31.8472C9.56222 32.5639 19.9755 32.5755 19.9755 32.5755C19.9755 32.5755 30.4172 32.5872 33.0272 31.9038C33.7314 31.7127 34.3735 31.3412 34.89 30.8258C35.4065 30.3105 35.7795 29.6692 35.9722 28.9655C36.6622 26.3572 36.6672 20.9455 36.6672 20.9455C36.6672 20.9455 36.7006 15.5038 35.9889 12.8938ZM16.6606 25.8972L16.6689 15.8972L25.3472 20.9055L16.6606 25.8972Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.cc7c9845e1482c3d2a54fc6518555f1d.svg";
export { ForwardRef as ReactComponent };